import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [,
	{
		path: '/404',
		name: '404',
		component: () => import('@/views/404')
	},
	{
		path: '*',
		redirect: {
			name: '404'
		}
	},
	{
		path: '/',
		name: 'Index',
		component: () => import('../views/index.vue'),
		meta: {
			keepAlive: true // 需要缓存的组件
		}
	},
	{
		path: '/detail/:id',
		name: 'Detail',
		component: () => import('../views/detail.vue')
	},
	{
		path: '/about',
		name: 'About',
		component: () => import('../views/certAbout.vue')
	},
	{
		path: '/moreNews',
		name: 'MoreNews',
		component: () => import('../views/moreNews.vue')
	},
	{
		path: '/moreInform',
		name: 'MoreInform',
		component: () => import('../views/moreInform.vue')
	},
	{
		path: '/moreCert',
		name: 'MoreCert',
		component: () => import('../views/moreCert.vue')
	},
	{
		path: '/exam/:name',
		name: 'exam',
		component: () => import('../views/exam.vue')
	},
	{
		path: '/course',
		component: () => import('../views/course/index.vue')
	},
	{
		path: '/course/login',
		component: () => import('../views/course/login.vue')
	},
	{
		path: '/course/detail',
		component: () => import('../views/course/detail.vue')
	},
	{
		path: '/course/video',
		component: () => import('../views/course/video.vue')
	},
	{
		path: '/partner',
		component: () => import('../views/partner/index.vue')
	},
	{
		path: '/partner/result/:name',
		component: () => import('../views/partner/result.vue')
	}
]

/**
 * 解决报错问题：报错显示是路由重复
 * Error: Avoided redundant navigation to current location
 */
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
	routes,
	mode: 'history'
})

router.afterEach((to, from, next) => {
	window.scrollTo(0, 0);
});

export default router
